// extracted by mini-css-extract-plugin
module.exports = {"efaxOrdersLabel":"InboxSidebar_efaxOrdersLabel__3H2Uh","unassignedEfaxes":"InboxSidebar_unassignedEfaxes__3cEcU"};